import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDropzone } from 'react-dropzone';
import Cookies from 'js-cookie';
import { useParams } from "react-router-dom";
import Rating from '@mui/material/Rating';
import {
  Grid,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  ButtonGroup
} from '@material-ui/core';

import Skeleton from '@material-ui/lab/Skeleton';
import Pagination from '@material-ui/lab/Pagination';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  SwipeableDrawer,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  Tooltip,
  Box,
  Card,
  CardContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import {
  DataGrid,
 
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid';

import {
  useMaterialReactTable,
  MaterialReactTable
  
} from 'material-react-table';

import ReactApexChart from "react-apexcharts";
import { styled } from '@material-ui/styles';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import Rodape from '../../../../../../components/Rodape';

// Icons (todos únicos)
import HomeIcon from '@mui/icons-material/Home';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import GavelIcon from '@mui/icons-material/Gavel';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import GarageIcon from '@mui/icons-material/Garage';
import CarRentalIcon from '@mui/icons-material/CarRental';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import WarningIcon from "@mui/icons-material/Warning";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
const drawerWidth = 240;

const dropzoneStyles = {
  border: '4px dashed #000000',
  borderRadius: '4px',
  padding: '2px',
  textAlign: 'center',
  cursor: 'pointer',
  margin: '2px 0',
};



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& .cabecalho_transparente': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      color: 'rgba(0, 0, 0, 0)',
    },
    '& .cabecalho_azul': {
      backgroundColor: 'rgba(0, 0, 255, 1)',
      color: 'white',
    },
    '& .cabecalho_verde': {
      backgroundColor: 'rgba(0, 100, 0, 1)',
      color: 'white',
    },
    '& .cabecalho_verde_claro': {
      backgroundColor: 'rgba(107,142,35, 1)',
      color: 'white',
    },
    '& .cabecalho_marrom_claro': {
      backgroundColor: 'rgba(184,134,11, 1)',
      color: 'white',
    },
    '& .cabecalho_verde_cyan': {
      backgroundColor: 'rgba(0,139,139, 1)',
      color: 'white',
    },
    '& .cabecalho_verde_dark_sea': {
      backgroundColor: 'rgba(60,179,113, 1)',
      color: 'white',
    },
    '& .cabecalho_marrom_escuro': {
      backgroundColor: 'rgba(139,69,19, 1)',
      color: 'white',
    },
    '& .cabecalho_marrom_chocolate': {
      backgroundColor: 'rgba(210,105,30, 1)',
      color: 'white',
    },
    '& .cabecalho_darkslate': {
      backgroundColor: 'rgba(47,79,79, 1)',
      color: 'white',
    },
    '& .super-app.negative': {
      backgroundColor: 'rgba(157, 255, 118, 0.49)',
      color: '#1a3e72',
      fontWeight: '600',
    },
    '& .super-app.positive': {
      backgroundColor: '#d47483',
      color: '#1a3e72',
      fontWeight: '600',
    },
    '& .super-app.neutro': {
      backgroundColor: '#363636',
      color: 'white',
      fontWeight: '600',
    },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  table: {
    minWidth: 650,
  },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: 'green',
  borderColor: 'black',
  '&:hover': {
    backgroundColor: 'green',
    color: 'blue',
    borderColor: 'blue',
  },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: 'red',
  borderColor: 'black',
  '&:hover': {
    backgroundColor: 'red',
    color: 'white',
    borderColor: 'blue',
  },
}));

function novo() {
  window.location.href = "/gestao/operacional/frota/veiculos/cadastrarveiculo"

}


const formatBRL = (value) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function Veiculos() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [darkMode, setDarkMode] = useState(isMobile || Cookies.get('darkMode') === 'true');

  useEffect(() => {
    const handleDarkModeChange = () => {
      const isDark = isMobile || Cookies.get('darkMode') === 'true'; // Force dark on mobile
      setDarkMode(isDark);
    };

    window.addEventListener('darkModeChanged', handleDarkModeChange);
    return () => window.removeEventListener('darkModeChanged', handleDarkModeChange);
  }, [isMobile]);

  const [loading, setLoading] = useState(true);
  const [objetos, setObjetos] = useState([]);
  const [loadingDashboard, setLoadingDashboard] = useState(true);

  const [motoristas, setMotoristas] = useState([]);
  const [loadingMotoristas, setLoadingMotoristas] = useState(true);


  const { value: valueParam } = useParams();
  const [value, setValue] = useState(1); // Mudei para 1 (Lista) por padrão para evitar carregar dashboard pesado no início

  const hoje = new Date();

  const [diaD, setDiaD] = useState('');
  const [mesD, setMesD] = useState('');
  const [anoD, setAnoD] = useState(String(hoje.getFullYear()));

  const [rowCount, setRowCount] = useState(0);
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const [paginationMotoristas, setPaginationMotoristas] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

  useEffect(() => {
    if (value === 0) {
      listarInfoDashboard();
    }
  }, [value]);


  const handleMenuClick = (newValue) => {
    if (newValue === 0) {
      listarInfoDashboard();
    } else if (newValue === 1) {
      listar();
    } else if (newValue === 2) {
      listarMotoristas();
    }
    setValue(newValue);
  };


  const [infoDashboard, setInfoDashboard] = useState(null);

  async function listarInfoDashboard() {


    try {
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }

      await api.get("v1/protected/veiculos/listarinfodashboard", {
        headers: headers
      }).then(function (response) {

        setInfoDashboard(response.data);

        setLoadingDashboard(false);

      });


    } catch (_err) {
      // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
      console.log("Erro ao listar dados de dashboard sobre veiculos: " + _err)
      alert("Erro ao listar dados de dashboard sobre veiculos: " + _err);

    }

  }



  async function listarMotoristas() {


    try {
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }

      await api.get("v1/protected/veiculos/listarmotoristas", {
        headers: headers
      }).then(function (response) {

        setMotoristas(response.data);

        setLoadingMotoristas(false);

      });


    } catch (_err) {
      // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
      console.log("Erro ao listar dados de dashboard sobre veiculos: " + _err)
      alert("Erro ao listar dados de dashboard sobre veiculos: " + _err);

    }

  }

  const [dadosGrafico, setDadosGrafico] = useState({
    series: [
      { name: 'Multas', data: [] },
    ],
    options: {
      chart: {
        height: '100%',
        type: 'line',
        width: '100%',
      },
      colors: ['#0288d1'], // Cor principal da linha
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 4, // Define a espessura da linha
        curve: 'smooth', // Faz a linha suave (opcional)
        colors: ['#0288d1'], // Cor da linha
      },
      responsive: [
        {
          breakpoint: 768, // Para telas menores que 768px
          options: {
            chart: {
              width: '100%',
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      xaxis: {
        categories: [], // As categorias (dias do mês)
        title: {
          text: 'Mês do Ano', // Opcional: título do eixo X
        },
      },
      yaxis: {
        title: {
          text: 'Multas',
        },
      },
      markers: {
        size: 5, // Tamanho dos pontos
        colors: ['#0288d1'], // Cor dos pontos
        strokeColors: '#fff', // Cor da borda do ponto
        strokeWidth: 2, // Espessura da borda dos pontos
      },
      fill: {
        opacity: 1,
      },
    },
  });



  const [dadosGraficoManutencao, setDadosGraficoManutencao] = useState({
    series: [
      { name: 'Manutenções', data: [] },
    ],
    options: {
      chart: {
        height: '100%',
        type: 'line',
        width: '100%',
      },
      colors: ['#0288d1'], // Cor principal da linha
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 4, // Define a espessura da linha
        curve: 'smooth', // Faz a linha suave (opcional)
        colors: ['#0288d1'], // Cor da linha
      },
      responsive: [
        {
          breakpoint: 768, // Para telas menores que 768px
          options: {
            chart: {
              width: '100%',
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      xaxis: {
        categories: [], // As categorias (dias do mês)
        title: {
          text: 'Mês do Ano', // Opcional: título do eixo X
        },
      },
      yaxis: {
        title: {
          text: 'Manutenções',
        },
      },
      markers: {
        size: 5, // Tamanho dos pontos
        colors: ['#0288d1'], // Cor dos pontos
        strokeColors: '#fff', // Cor da borda do ponto
        strokeWidth: 2, // Espessura da borda dos pontos
      },
      fill: {
        opacity: 1,
      },
    },
  });






  const [dadosGraficoAcidentes, setDadosGraficoAcidentes] = useState({
    series: [
      { name: 'Acidentes', data: [] },
    ],
    options: {
      chart: {
        height: '100%',
        type: 'line',
        width: '100%',
      },
      colors: ['#0288d1'], // Cor principal da linha
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 4, // Define a espessura da linha
        curve: 'smooth', // Faz a linha suave (opcional)
        colors: ['#0288d1'], // Cor da linha
      },
      responsive: [
        {
          breakpoint: 768, // Para telas menores que 768px
          options: {
            chart: {
              width: '100%',
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      xaxis: {
        categories: [], // As categorias (dias do mês)
        title: {
          text: 'Mês do Ano', // Opcional: título do eixo X
        },
      },
      yaxis: {
        title: {
          text: 'Acidentes',
        },
      },
      markers: {
        size: 5, // Tamanho dos pontos
        colors: ['#0288d1'], // Cor dos pontos
        strokeColors: '#fff', // Cor da borda do ponto
        strokeWidth: 2, // Espessura da borda dos pontos
      },
      fill: {
        opacity: 1,
      },
    },
  });



  const dadosFiltrados = useMemo(() => {
    if (!infoDashboard?.ocorrencias) return [];

    return infoDashboard.ocorrencias.filter(r => {
      let y, m, d;

      if (!r.data_ocorrencia) return false;

      if (typeof r.data_ocorrencia === "string") {
        // formato "yyyy-MM-dd"
        [y, m, d] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        // formato [yyyy, m, d]
        [y, m, d] = r.data_ocorrencia.map(n => String(n).padStart(2, "0"));
      } else if (typeof r.data_ocorrencia === "object") {
        // formato { year, month, day }
        y = String(r.data_ocorrencia.year).padStart(4, "0");
        m = String(r.data_ocorrencia.month).padStart(2, "0");
        d = String(r.data_ocorrencia.day).padStart(2, "0");
      } else {
        return false;
      }

      if (mesD && m !== mesD) return false;
      if (anoD && y !== anoD) return false;
      if (diaD && d !== diaD) return false;

      return true;
    });
  }, [infoDashboard, diaD, mesD, anoD]);


  const dadosFiltradosAno = useMemo(() => {
    if (!infoDashboard?.ocorrencias) return [];

    return infoDashboard.ocorrencias.filter(r => {
      let y;

      if (!r.data_ocorrencia) return false;

      if (typeof r.data_ocorrencia === "string") {
        // formato "yyyy-MM-dd"
        [y] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        // formato [yyyy, m, d]
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        // formato { year, month, day }
        y = String(r.data_ocorrencia.year).padStart(4, "0");
      } else {
        return false;
      }

      // Filtra pelo ano e pelo tipo_ocorrencia
      return (anoD ? y === anoD : true) && r.tipo_ocorrencia === 0;
    });
  }, [infoDashboard, anoD]);



  useEffect(() => {
    if (!dadosFiltradosAno.length) return;

    const agrupadoPorMes = {};

    dadosFiltradosAno.forEach(r => {
      let y, m;

      if (typeof r.data_ocorrencia === "string") {
        [y, m] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
        m = String(r.data_ocorrencia[1]).padStart(2, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        y = String(r.data_ocorrencia.year).padStart(4, "0");
        m = String(r.data_ocorrencia.month).padStart(2, "0");
      }

      if (anoD && y !== anoD) return;

      if (!agrupadoPorMes[m]) {
        agrupadoPorMes[m] = { totalValor: 0, totalQtd: 0 };
      }

      if (r.tipo_ocorrencia === 0) {
        agrupadoPorMes[m].totalValor += r.valor ?? 0;
        agrupadoPorMes[m].totalQtd += 1;
      }
    });

    const mesesOrdenados = Object.keys(agrupadoPorMes).sort((a, b) => a - b);

    const categorias = mesesOrdenados.map(mesNum => {
      const nomeMes = new Date(2000, mesNum - 1, 1)
        .toLocaleString('pt-BR', { month: 'short' });
      return nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);
    });

    const valores = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalValor);
    const quantidades = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalQtd);

    // Aqui calculamos os máximos e aplicamos 20% de padding
    const maxValor = Math.max(...valores);
    const maxQtd = Math.max(...quantidades);
    setDadosGrafico(prevState => ({
      ...prevState,
      series: [
        { name: 'Valor Total Multas', data: valores },
        { name: 'Quantidade de Multas', data: quantidades }
      ],
      options: {
        ...prevState.options,
        chart: { height: '100%', type: 'area', width: '100%', toolbar: { show: true } },
        colors: ['#0288d1', '#000000'],
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: ['#0288d1', '#000000'] // força a linha preta para a segunda série
        },
        fill: {
          type: 'gradient',
          gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0, stops: [0, 90, 100] }
        },
        markers: {
          size: 5,
          colors: ['#0288d1', '#000000'], // cores dos pontos
          strokeColors: '#fff',
          strokeWidth: 2
        },
        xaxis: { categories: categorias, title: { text: 'Meses do Ano' } },
        yaxis: [
          { title: { text: 'Valor (R$)' }, max: maxValor * 1.2 },
          { opposite: true, title: { text: 'Quantidade' }, max: maxQtd * 1.2 }
        ],
        tooltip: { shared: true },
        dataLabels: { enabled: true }
      }
    }));
  }, [dadosFiltradosAno, anoD]);



  const dadosFiltradosManutencaoAno = useMemo(() => {
    if (!infoDashboard?.ocorrencias) return [];

    return infoDashboard.ocorrencias.filter(r => {
      let y;

      if (!r.data_ocorrencia) return false;

      if (typeof r.data_ocorrencia === "string") {
        // formato "yyyy-MM-dd"
        [y] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        // formato [yyyy, m, d]
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        // formato { year, month, day }
        y = String(r.data_ocorrencia.year).padStart(4, "0");
      } else {
        return false;
      }

      // Filtra pelo ano e pelo tipo_ocorrencia
      return (anoD ? y === anoD : true) && r.tipo_ocorrencia === 10;
    });
  }, [infoDashboard, anoD]);






  const dadosFiltradosAcidentesAno = useMemo(() => {
    if (!infoDashboard?.ocorrencias) return [];

    return infoDashboard.ocorrencias.filter(r => {
      let y;

      if (!r.data_ocorrencia) return false;

      if (typeof r.data_ocorrencia === "string") {
        // formato "yyyy-MM-dd"
        [y] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        // formato [yyyy, m, d]
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        // formato { year, month, day }
        y = String(r.data_ocorrencia.year).padStart(4, "0");
      } else {
        return false;
      }

      // Filtra pelo ano e pelo tipo_ocorrencia
      return (anoD ? y === anoD : true) && r.tipo_ocorrencia === 20;
    });
  }, [infoDashboard, anoD]);



  useEffect(() => {
    if (!dadosFiltradosManutencaoAno.length) return;

    const agrupadoPorMes = {};

    dadosFiltradosManutencaoAno.forEach(r => {
      let y, m;

      if (typeof r.data_ocorrencia === "string") {
        [y, m] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
        m = String(r.data_ocorrencia[1]).padStart(2, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        y = String(r.data_ocorrencia.year).padStart(4, "0");
        m = String(r.data_ocorrencia.month).padStart(2, "0");
      }

      if (anoD && y !== anoD) return;

      if (!agrupadoPorMes[m]) {
        agrupadoPorMes[m] = { totalValor: 0, totalQtd: 0 };
      }

      if (r.tipo_ocorrencia === 10) {
        agrupadoPorMes[m].totalValor += r.valor ?? 0;
        agrupadoPorMes[m].totalQtd += 1;
      }
    });

    const mesesOrdenados = Object.keys(agrupadoPorMes).sort((a, b) => a - b);

    const categorias = mesesOrdenados.map(mesNum => {
      const nomeMes = new Date(2000, mesNum - 1, 1)
        .toLocaleString('pt-BR', { month: 'short' });
      return nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);
    });

    const valores = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalValor);
    const quantidades = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalQtd);

    // Aqui calculamos os máximos e aplicamos 20% de padding
    const maxValor = Math.max(...valores);
    const maxQtd = Math.max(...quantidades);
    setDadosGraficoManutencao(prevState => ({
      ...prevState,
      series: [
        { name: 'Valor Total Manutenções', data: valores },
        { name: 'Quantidade de Manutenções', data: quantidades }
      ],
      options: {
        ...prevState.options,
        chart: { height: '100%', type: 'area', width: '100%', toolbar: { show: true } },
        colors: ['#0288d1', '#000000'],
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: ['#0288d1', '#000000'] // força a linha preta para a segunda série
        },
        fill: {
          type: 'gradient',
          gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0, stops: [0, 90, 100] }
        },
        markers: {
          size: 5,
          colors: ['#0288d1', '#000000'], // cores dos pontos
          strokeColors: '#fff',
          strokeWidth: 2
        },
        xaxis: { categories: categorias, title: { text: 'Meses do Ano' } },
        yaxis: [
          { title: { text: 'Valor (R$)' }, max: maxValor * 1.2 },
          { opposite: true, title: { text: 'Quantidade' }, max: maxQtd * 1.2 }
        ],
        tooltip: { shared: true },
        dataLabels: { enabled: true }
      }
    }));
  }, [dadosFiltradosManutencaoAno, anoD]);






  useEffect(() => {
    if (!dadosFiltradosAcidentesAno.length) return;

    const agrupadoPorMes = {};

    dadosFiltradosAcidentesAno.forEach(r => {
      let y, m;

      if (typeof r.data_ocorrencia === "string") {
        [y, m] = r.data_ocorrencia.split("-");
      } else if (Array.isArray(r.data_ocorrencia)) {
        y = String(r.data_ocorrencia[0]).padStart(4, "0");
        m = String(r.data_ocorrencia[1]).padStart(2, "0");
      } else if (typeof r.data_ocorrencia === "object") {
        y = String(r.data_ocorrencia.year).padStart(4, "0");
        m = String(r.data_ocorrencia.month).padStart(2, "0");
      }

      if (anoD && y !== anoD) return;

      if (!agrupadoPorMes[m]) {
        agrupadoPorMes[m] = { totalValor: 0, totalQtd: 0 };
      }

      if (r.tipo_ocorrencia === 20) {
        agrupadoPorMes[m].totalValor += r.valor ?? 0;
        agrupadoPorMes[m].totalQtd += 1;
      }
    });

    const mesesOrdenados = Object.keys(agrupadoPorMes).sort((a, b) => a - b);

    const categorias = mesesOrdenados.map(mesNum => {
      const nomeMes = new Date(2000, mesNum - 1, 1)
        .toLocaleString('pt-BR', { month: 'short' });
      return nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);
    });

    const valores = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalValor);
    const quantidades = mesesOrdenados.map(mesNum => agrupadoPorMes[mesNum].totalQtd);

    // Aqui calculamos os máximos e aplicamos 20% de padding
    const maxValor = Math.max(...valores);
    const maxQtd = Math.max(...quantidades);
    setDadosGraficoAcidentes(prevState => ({
      ...prevState,
      series: [
        { name: 'Valor Total Acidentes', data: valores },
        { name: 'Quantidade de Acidentes', data: quantidades }
      ],
      options: {
        ...prevState.options,
        chart: { height: '100%', type: 'area', width: '100%', toolbar: { show: true } },
        colors: ['#0288d1', '#000000'],
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: ['#0288d1', '#000000'] // força a linha preta para a segunda série
        },
        fill: {
          type: 'gradient',
          gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0, stops: [0, 90, 100] }
        },
        markers: {
          size: 5,
          colors: ['#0288d1', '#000000'], // cores dos pontos
          strokeColors: '#fff',
          strokeWidth: 2
        },
        xaxis: { categories: categorias, title: { text: 'Meses do Ano' } },
        yaxis: [
          { title: { text: 'Valor (R$)' }, max: maxValor * 1.2 },
          { opposite: true, title: { text: 'Quantidade' }, max: maxQtd * 1.2 }
        ],
        tooltip: { shared: true },
        dataLabels: { enabled: true }
      }
    }));
  }, [dadosFiltradosAcidentesAno, anoD]);


  const totais = useMemo(() => {
    const multas = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 0) {
        return acc + Number(oc.valor || 0);
      }
      return acc;
    }, 0);

    const nMultas = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 0) {
        return acc + 1;
      }
      return acc;
    }, 0);


    const manutencoes = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 10) {
        return acc + Number(oc.valor || 0);
      }
      return acc;
    }, 0);

    const nManutencoes = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 10) {
        return acc + 1;
      }
      return acc;
    }, 0);


    const acidentes = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 20) {
        return acc + Number(oc.valor || 0);
      }
      return acc;
    }, 0);

    const nAcidentes = dadosFiltrados.reduce((acc, oc) => {
      if (oc.tipo_ocorrencia === 20) {
        return acc + 1;
      }
      return acc;
    }, 0);


    return { multas, nMultas, manutencoes, nManutencoes, nAcidentes, acidentes };
  }, [dadosFiltrados]);

  const onDropArquivo1 = useCallback(async (acceptedFiles) => {
    // Valida o tipo de arquivo
    // Valida o tipo de arquivo
    if (!acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      alert('Apenas arquivos Excel são permitidos.');
      return;
    }

    try {

      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }


      const formData = new FormData();
      formData.append('arquivos', acceptedFiles[0]);
      formData.append('extensao', acceptedFiles[0].name.split('.').pop());

      const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
      await api.post("/v1/protected/veiculos/rastreamento/upload/" + id_usuario_logado, formData, {
        headers: headers
      }).then(function (response) {

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {



          alert("Arquivo Lido!");

        } else {
          // Lógica a ser executada caso ocorra algum erro durante o salvamento
          alert("Erro ao processar, insira os itens manualmente!");
        }


      });





    } catch (_err) {
      console.log("erro ao cadastrar: " + _err);
      alert("Erro de Conexão, tente novamente mais tarde");
    }
  }, []);


  const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
    onDrop: onDropArquivo1,
    multiple: false, // Apenas um arquivo pode ser selecionado
    //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

  });


  const listar = useCallback(async () => {

    setLoading(true);

    try {
      const token = Cookies.get('token');

      const headers = {
        'Authorization': 'Bearer ' + token
      }

      const params = {
        busca: globalFilter,
        page: pagination.pageIndex,
        size: pagination.pageSize
      };


      await api.get("v1/protected/veiculos/listartodos", {
        headers: headers,
        params: params
      }).then(function (response) {
        setObjetos(response.data.dados);
        setRowCount(response.data.total);
        setLoading(false);
      });


    } catch (_err) {

      console.log("Erro ao listar objetos: " + _err)
      setLoading(false);

    }

  }, [globalFilter, pagination.pageIndex, pagination.pageSize]);


  useEffect(() => {
    if (value === 1) {
      listar();
    }
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, value, listar]);




  const handleClickGerenciar = (event, cellValues) => {


    window.location.href = "/gestao/operacional/frota/veiculos/gerenciar/" + cellValues.row.id_veiculo;


  };





  const [filteredData, setFilteredData] = useState([]);

  function formatarDataBR(dateObj) {
    let dia = String(dateObj.getDate()).padStart(2, '0');
    let mes = String(dateObj.getMonth() + 1).padStart(2, '0');
    let ano = dateObj.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  function returnDescricaoAtribuicao(atribuicao) {
    var dataBR = formatarDataBR(new Date(atribuicao.data_retirada));

    var texto = "Veículo em uso\n" +
      "Motorista: " + atribuicao.responsavel.nome + " " + atribuicao.responsavel.sobrenome + "\n" +
      "Data retirada: " + dataBR + " às " + atribuicao.hora_retirada;

    return texto;
  }


  const columns = useMemo(
    () => [



      {
        accessorKey: 'id_veiculo',
        id: 'id_veiculo', // Força o ID para bater com o campo do banco
        header: 'ID',
        size: 60,
      },
      {
        accessorKey: 'status_veiculo',
        header: 'Status Veículo',
        size: 100,
        Cell: ({ row }) => {
          let bgColor = '';
          let texto = '';

          switch (row.original.status_veiculo) {
            case 0:
              bgColor = '#4CAF50'; // verde
              texto = 'APTO';
              break;
            case 1:
              bgColor = '#F44336'; // vermelho
              texto = 'INABILITADO';
              break;
            case 2:
              bgColor = '#FFEB3B'; // amarelo
              texto = 'EM MANUTENÇÃO';
              break;
            case 3:
              bgColor = '#2196F3'; // azul
              texto = 'IRREGULAR';
              break;
            default:
              texto = '';
              bgColor = 'transparent';
          }

          return (
            <div
              style={{
                backgroundColor: bgColor,
                color: row.original.status_veiculo === 2 ? '#000' : '#fff', // preto no amarelo
                padding: '4px 8px',
                borderRadius: '4px',
                textAlign: 'center',
                fontWeight: 'bold'
              }}
            >
              {texto}
            </div>
          );
        }
      },
      {
        accessorKey: 'placa',
        header: 'Placa',
        size: 100,
      },

      {
        accessorKey: 'tipo_propriedade',
        header: 'Propriedade',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_propriedade) {
            case 0: return 'Próprio';
            case 1: return 'Alugado';
            default: return row.original.tipo_propriedade;
          }
        },
      },


      {
        accessorKey: 'tipo_veiculo',
        header: 'Tipo Veículo',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_veiculo) {
            case 0: return 'Carro';
            case 1: return 'Moto';
            case 2: return 'Caminhão';
            case 3: return 'Van';
            default: return '';
          }
        },
      },

      {
        header: 'Motorista',
        id: 'atribuicao',
        size: 350,
        accessorFn: row => {
          return {
            atribuicao: row.atribuicao,

          };

        },
        Cell: ({ row }) => {
          const atribuicao = row.original.atribuicao;
          const descricao = atribuicao
            ? returnDescricaoAtribuicao(atribuicao)
            : "Veículo Ocioso";

          return (
            <span style={{ fontSize: 14, color: 'black', fontWeight: 'bold' }}>
              {descricao.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          );
        }
      },



      {
        accessorKey: 'tipo_chassi',
        header: 'Tipo Chassi',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_chassi) {
            case 0: return 'Passeio';
            case 1: return 'Utilitário';
            case 2: return 'Sedan';
            case 3: return 'Sport';
            case 4: return 'Caminhonete';
            default: return '';
          }
        },
      },
      {
        accessorKey: 'tipo_motor',
        header: 'Tipo Motor',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_motor) {
            case 0: return 'Gasolina';
            case 1: return 'Álcool';
            case 2: return 'Diesel';
            case 3: return 'Flex';
            case 4: return 'Elétrico';
            default: return '';
          }
        },
      },
      {
        accessorKey: 'tipo_eixos',
        header: 'Tipo Eixos',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_eixos) {
            case 0: return 'Tração Dianteira';
            case 1: return 'Tração Traseira';
            case 2: return '4x4';
            default: return '';
          }
        },
      },
      {
        accessorKey: 'chassi',
        header: 'Chassi',
        size: 100,
      },
      {
        accessorKey: 'renavam',
        header: 'Renavam',
        size: 100,
      },

      {
        accessorKey: 'status_documentacao',
        header: 'Status Documentação',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.status_documentacao) {
            case 0: return 'IRREGULAR';
            case 1: return 'REGULAR';
            case 2: return 'VENCIDO';
            case 3: return 'BAIXADO';
            default: return '';
          }
        },
      },
      {
        accessorKey: 'tipo_transmissao',
        header: 'Tipo Transmissão',
        size: 100,
        Cell: ({ row }) => {
          switch (row.original.tipo_transmissao) {
            case 0: return 'Manual';
            case 1: return 'Automática';
            default: return '';
          }
        },
      },



      {
        accessorKey: 'marca',
        header: 'Marca',
        size: 100,
      },
      {
        accessorKey: 'modelo',
        header: 'Modelo',
        size: 100,
      },
      {
        accessorKey: 'ano_modelo',
        header: 'Ano Modelo',
        size: 100,
      },
      {
        accessorKey: 'ano_veiculo',
        header: 'Ano Veículo',
        size: 100,
      },
      {
        accessorKey: 'cor',
        header: 'Cor',
        size: 100,
      },
      {
        accessorKey: 'num_ocupantes',
        header: 'Número de Ocupantes',
        size: 100,
      },
      {
        accessorKey: 'capacidade_porta_malas',
        header: 'Capacidade Porta-Malas',
        size: 100,
      },
      {
        accessorKey: 'descricao',
        header: 'Descrição',
        size: 100,
      },

    ],
    [],
  );

  const table = useMaterialReactTable({
    columns: columns,
    data: objetos,
    enableGlobalFilterModes: false, 
    enablePagination: true,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    state: {
      pagination,
      sorting,
      globalFilter,
      isLoading: loading,
    },
    enableRowActions: true,
    paginationDisplayMode: 'pages',
    getRowId: (row) => row.id_veiculo,
    enableTopToolbar: true,
    enableBottomToolbar: true,
    enableColumnFilters: false, 
    enableColumnActions: false,
    sortable: true,
    enableSorting: true,
    enableRowSelection: false,
    enableExpandAll: false,
    enableColumnPinning: true,
    enableColumnResizing: true,
    initialState: {
      density: 'compact',
    },
    muiTableContainerProps: {
      sx: {
        maxHeight: 'calc(100vh - 190px)',
        overflow: 'auto',
      },
    },
    muiTopToolbarProps: {
      sx: {
        bgcolor: darkMode ? '#121212' : 'background.default',
        '& .MuiIconButton-root, & .MuiSvgIcon-root, & .MuiInputBase-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      },
    },
    muiBottomToolbarProps: {
      sx: {
        bgcolor: darkMode ? '#121212' : 'background.default',
        '& .MuiIconButton-root, & .MuiSvgIcon-root, & .MuiTablePagination-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      },
    },
    muiTableHeadCellProps: {
      sx: {
        padding: '4px',
        fontSize: '0.75rem',
        backgroundColor: darkMode ? '#000 !important' : '#fff !important',
        color: darkMode ? '#fff !important' : '#000 !important',
      },
    },
    renderTopToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: '1rem', p: '4px', alignItems: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={novo}
          startIcon={<AddCircleOutlineIcon />}
          sx={{ height: '32px', textTransform: 'none' }}
        >
          Novo Veículo
        </Button>

        <div {...getRootArquivoProps1()} style={{ ...dropzoneStyles, padding: '5px 15px', minHeight: 'auto', border: darkMode ? '1px dashed #666' : '1px dashed #ccc', margin: 0 }}>
          <input {...getInputArquivoProps1()} />
          <Typography align="center" variant="body2" sx={{ color: darkMode ? '#aaa' : '#666', fontSize: '0.75rem' }}>
            Novo Anexo (Arraste ou clique)
          </Typography>
        </div>
      </Box>
    ),
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      variant: 'outlined',
    },
    muiTablePaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      sx: {
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiSelect-select, & .MuiSelect-icon, & .MuiIconButton-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      }
    },
    enableFullScreenToggle: true,
    renderRowActions: ({ row }) => (
      <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
        <Tooltip title="Gerenciar">
          <IconButton
            color="primary"
            href={"/gestao/operacional/frota/veiculos/gerenciar/" + row.original.id_veiculo}
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  });







  const columnsMotoristas = useMemo(
    () => [



      {
        accessorKey: 'idcolaborador', //normal accessorKey
        header: 'ID',
        size: 60,
      },

      {
        header: 'Responsável',
        size: 350,
        accessorFn: (row) => row,
        Cell: ({ row }) => {

          return (
            <span style={{ fontSize: 14, color: 'black', fontWeight: 'bold' }}>
              {row.original.nome + " " + row.original.sobrenome}
            </span>
          );
        }
      },

      {
        accessorKey: 'cpf', //normal accessorKey
        header: 'CPF',
        size: 150,
      },

      {
        accessorKey: 'classificacao',
        header: 'Nota',
        size: 150,
        Cell: ({ row }) => {
          var nota = row.original.classificacao;
          return (
            <Box component="fieldset" mb={3} borderColor="transparent">
              <Rating
                name="simple-controlled"
                value={nota}
                precision={1}
                max={5}
                emptyIcon={<StarBorderIcon />}
                readOnly
              />
            </Box>
          );
        }
      },

      {
        accessorKey: 'quantidadeocorrencias', //normal accessorKey
        header: 'Quantidade de Ocorrências ',
        size: 150,
      },

      {
        accessorKey: 'quantidademultas', //normal accessorKey
        header: 'Quantidade de Multas',
        size: 150,
      },

      {
        accessorKey: 'quantidademanutencoes', //normal accessorKey
        header: 'Quantidade de Manutençôes',
        size: 150,
      },

      {
        accessorKey: 'quantidadeadvertencias', //normal accessorKey
        header: 'Quantidade de Advertências',
        size: 150,
      },


    ],
    [],
  );





  const tableMotoristas = useMaterialReactTable({
    columns: columnsMotoristas,
    data: motoristas,
    enableGlobalFilterModes: true,
    enablePagination: true,
    enableRowActions: true,
    paginationDisplayMode: 'pages',
    getRowId: (row) => row.id_veiculo,
    enableTopToolbar: true,
    enableBottomToolbar: true,
    enableColumnFilters: true,
    enableColumnActions: false,
    sortable: true,
    enableSorting: true,
    enableRowSelection: false,
    enableColumnFilterModes: true,
    enableExpandAll: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    state: {
       pagination: paginationMotoristas,
       isLoading: loadingMotoristas,
    },
    onPaginationChange: setPaginationMotoristas,
    initialState: {
      showGlobalFilter: true,
      density: 'compact',
    },
    muiTableContainerProps: {
      sx: {
        maxHeight: 'calc(100vh - 190px)',
        overflow: 'auto',
      },
    },
    muiTopToolbarProps: {
      sx: {
        bgcolor: darkMode ? '#121212' : 'background.default',
        '& .MuiIconButton-root, & .MuiSvgIcon-root, & .MuiInputBase-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      },
    },
    muiBottomToolbarProps: {
      sx: {
        bgcolor: darkMode ? '#121212' : 'background.default',
        '& .MuiIconButton-root, & .MuiSvgIcon-root, & .MuiTablePagination-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      },
    },
    muiTableHeadCellProps: {
      sx: {
        padding: '4px',
        fontSize: '0.75rem',
        backgroundColor: darkMode ? '#000 !important' : '#fff !important',
        color: darkMode ? '#fff !important' : '#000 !important',
      },
    },
    muiTablePaginationProps: {
      sx: {
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiSelect-select, & .MuiSelect-icon, & .MuiIconButton-root': {
          color: darkMode ? '#fff !important' : 'inherit',
        }
      }
    },
    renderTopToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: '1rem', p: '4px', alignItems: 'center' }}>
        <Typography variant="caption" sx={{ color: darkMode ? '#fff' : 'inherit', fontWeight: 'bold' }}>
           Motoristas
        </Typography>
      </Box>
    ),
    muiPaginationProps: {
      rowsPerPageOptions: [100, 500, 1000],
      variant: 'outlined',
    },
    enableFullScreenToggle: true,
    renderDetailPanel: ({ row }) => (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-around',
          left: '30px',
          maxWidth: '1000px',
          position: 'sticky',
          width: '100%',
        }}
      />
    ),

  });

  return (
    <div>

      <NavegadorGestao
        Operacional={true}
        Veiculos={true}
        corFundo={'white'} travado={true} corTexto={'black'}
      />


      {value === 0 &&
        <div style={{ paddingTop: 5, paddingLeft: 220, width: '100%', backroungcolor: '#f0f4f4' }}>
          {!loadingDashboard &&
            <Grid item xs={12} container style={{ width: '100%', margin: 1 }} direction={'row'} >





              {/* Linha 1 */}
              <Grid item xs={12} container
                style={{ width: '100%', margin: 1 }}
                direction={'row'}
                spacing={1}
              >
                <Grid item xs={4}
                  style={{
                    padding: '10px',
                    backgroundColor: '#00008B',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    margin: '2px',
                    display: 'flex', // Adiciona flexbox
                    flexDirection: 'column', // Coloca os itens em coluna
                    alignItems: 'center', // Centraliza horizontalmente
                    justifyContent: 'center', // Centraliza verticalmente
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between', // Espaçamento entre os itens
                      paddingTop: '10px',
                      padding: '1px',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    <span style={{ fontWeight: 'bold', fontSize: '28px' }}>
                      Frota
                    </span>
                  </div>



                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center', // garante que ícone e texto fiquem alinhados verticalmente
                      justifyContent: 'center',
                      gap: '4px', // espaçamento entre ícone e texto
                      marginTop: '10px'
                    }}
                  >
                    <GarageIcon style={{ color: '#8cb911ff', fontSize: '36px' }} />
                    <Tooltip title="Número de Veículos total na frota">
                      <Typography style={{ lineHeight: 1, margin: 0, fontSize: '28px' }}>
                        {infoDashboard.dashboardInfo.totalVeiculos}
                      </Typography>
                    </Tooltip>
                  </div>

                  <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <HomeIcon style={{ color: '#00ff6aff', fontSize: '36px' }} />
                      <Tooltip title="Número de Veículos proprios na frota">
                        <Typography variant="body1" style={{ lineHeight: 1, margin: 0, fontSize: '28px' }}>
                          {infoDashboard.dashboardInfo.totalProprios}
                        </Typography>
                      </Tooltip>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <CarRentalIcon style={{ color: '#c76227ce', fontSize: '36px' }} />
                      <Tooltip title="Número de Veículos alugados na frota">
                        <Typography variant="body1" style={{ lineHeight: 1, margin: 0, fontSize: '28px' }}>
                          {infoDashboard.dashboardInfo.totalAlugados}
                        </Typography>
                      </Tooltip>
                    </div>
                  </div>







                </Grid>

                <Grid item xs={4}
                  style={{
                    padding: '10px',
                    backgroundColor: '#323738ff',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    margin: '2px',
                    display: 'flex', // Adiciona flexbox
                    flexDirection: 'column', // Coloca os itens em coluna
                    alignItems: 'center', // Centraliza horizontalmente
                    justifyContent: 'center', // Centraliza verticalmente
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between', // Espaçamento entre os itens
                      paddingTop: '10px',
                      padding: '1px',
                      borderRadius: '8px',
                      color: 'white',
                    }}
                  >
                    <span style={{ fontWeight: 'bold', fontSize: '28px' }}>
                      Status de Veículos
                    </span>
                  </div>



                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center', // garante que ícone e texto fiquem alinhados verticalmente
                      justifyContent: 'center',
                      gap: '4px', // espaçamento entre ícone e texto
                      marginTop: '10px'
                    }}
                  >
                    <DirectionsCarIcon style={{ color: '#14b41cff', fontSize: '36px' }} />
                    <Tooltip title="Número de Veículos Aptos">
                      <Typography style={{ lineHeight: 1, margin: 0, fontSize: '28px' }}>
                        {infoDashboard.dashboardInfo.totalAptos}
                      </Typography>
                    </Tooltip>
                  </div>

                  <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Box position="relative" display="inline-flex">
                        <DirectionsCarIcon style={{ fontSize: 40, color: 'gray' }} />
                        <BuildIcon style={{ fontSize: 20, color: 'red', position: 'absolute', top: 0, right: 0 }} />
                      </Box>
                      <Tooltip title="Número de Veículos em Manutenção">
                        <Typography variant="body1" style={{ lineHeight: 1, margin: 0, fontSize: '28px' }}>
                          {infoDashboard.dashboardInfo.totalManutencao}
                        </Typography>
                      </Tooltip>
                    </div>


                  </div>







                </Grid>




              </Grid>

              {/* Filtros centralizados */}
              <Grid style={{ paddingTop: '5px' }} container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
                <Grid item xs={3}>
                  <TextField
                    label="Dia"
                    value={diaD}
                    onChange={e => setDiaD(e.target.value)}
                    inputProps={{ maxLength: 2 }}
                    fullWidth
                    onBlur={() => {
                      // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
                      if (diaD.length === 1) setDiaD(diaD.padStart(2, '0'));
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="Mês"
                    value={mesD}
                    onChange={e => setMesD(e.target.value)}
                    inputProps={{ maxLength: 2 }}
                    fullWidth
                    onBlur={() => {
                      // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
                      if (mesD.length === 1) setMesD(mesD.padStart(2, '0'));
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    label="Ano"
                    value={anoD}
                    onChange={e => setAnoD(e.target.value)}
                    inputProps={{ maxLength: 4 }}
                    fullWidth
                  />
                </Grid>
              </Grid>


              <Grid container item xs={9} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <Grid item xs={12}
                  style={{
                    padding: '10px',
                    backgroundColor: '#008B8B',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    margin: '2px'
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <GavelIcon />
                  <span style={{ fontWeight: 'bold' }}>
                    {mesD && Number.isInteger(Number(mesD))
                      ? `Multas no Mês de ${meses[Number(mesD) - 1]}`
                      : 'Multas no Período'}
                  </span>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center', // Centraliza horizontalmente
                      marginTop: '2px',
                      alignItems: 'center',
                      gap: '8px' // Espaço entre os elementos
                    }}
                  >
                    <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                      {totais.nMultas} multas
                    </Typography>

                    <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                      {(totais.multas ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}
                  style={{
                    padding: '1px',

                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    marginTop: '1px',
                    marginRight: '1px',
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div style={{ width: '100%', height: '100%' }}>
                    <ReactApexChart
                      options={dadosGrafico.options}
                      series={dadosGrafico.series}
                      type="area"
                    />
                  </div>
                </Grid>


              </Grid>
              <Grid container item xs={3} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <div
                  style={{
                    flex: 1,
                    padding: '5px',
                    backgroundColor: '#191970',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    marginInline: '10px',
                  }}
                >


                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bold',
                      padding: '5px',
                      borderBottom: '1px solid white',
                    }}
                  >
                    <span style={{ flex: 1, fontSize: '12px' }}>#</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Tipo</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Quant.</span>
                  </div>

                  {infoDashboard.rankingMultas?.map((ranking, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '5px',
                        backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff',
                        color: 'black',
                        fontSize: '14px',
                      }}
                    >
                      <span style={{ flex: 1, textAlign: 'center' }}>
                        {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                      </span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.nome}</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.quantidade}</span>
                    </div>
                  ))}
                </div>
              </Grid>




              <Grid container item xs={3} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <div
                  style={{
                    flex: 1,
                    padding: '5px',
                    backgroundColor: '#191970',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    marginInline: '10px',
                  }}
                >


                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bold',
                      padding: '5px',
                      borderBottom: '1px solid white',
                    }}
                  >
                    <span style={{ flex: 1, fontSize: '12px' }}>#</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Tipo</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Quant.</span>
                  </div>

                  {infoDashboard.rankingManutencao?.map((ranking, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '5px',
                        backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff',
                        color: 'black',
                        fontSize: '14px',
                      }}
                    >
                      <span style={{ flex: 1, textAlign: 'center' }}>
                        {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                      </span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.nome}</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.quantidade}</span>
                    </div>
                  ))}
                </div>
              </Grid>

              <Grid container item xs={9} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <Grid item xs={12}
                  style={{
                    padding: '10px',
                    backgroundColor: '#250a85ff',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    margin: '2px'
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <BuildIcon />
                  <span style={{ fontWeight: 'bold' }}>
                    {mesD && Number.isInteger(Number(mesD))
                      ? `Manutenções no Mês de ${meses[Number(mesD) - 1]}`
                      : 'Manutenções no Período'}
                  </span>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center', // Centraliza horizontalmente
                      marginTop: '2px',
                      alignItems: 'center',
                      gap: '8px' // Espaço entre os elementos
                    }}
                  >
                    <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                      {totais.nManutencoes} manutenções
                    </Typography>

                    <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                      {(totais.manutencoes ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Box>
                  </Box>
                </Grid>


                <Grid item xs={12}
                  style={{
                    padding: '1px',

                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    marginTop: '1px',
                    marginRight: '1px',
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div style={{ width: '100%', height: '100%' }}>
                    <ReactApexChart
                      options={dadosGraficoManutencao.options}
                      series={dadosGraficoManutencao.series}
                      type="area"
                    />
                  </div>
                </Grid>

              </Grid>


              <Grid container item xs={9} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <Grid item xs={12}
                  style={{
                    padding: '10px',
                    backgroundColor: '#8f16f1ff',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    margin: '2px'
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <CarCrashIcon />
                  <span style={{ fontWeight: 'bold' }}>
                    {mesD && Number.isInteger(Number(mesD))
                      ? `Acidentes Mês de ${meses[Number(mesD) - 1]}`
                      : 'Acidentes no Período'}
                  </span>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center', // Centraliza horizontalmente
                      marginTop: '2px',
                      alignItems: 'center',
                      gap: '8px' // Espaço entre os elementos
                    }}
                  >
                    <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                      {totais.nAcidentes} acidentes
                    </Typography>

                    <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                      {(totais.acidentes ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}
                  style={{
                    padding: '1px',

                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    marginTop: '1px',
                    marginRight: '1px',
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div style={{ width: '100%', height: '100%' }}>
                    <ReactApexChart
                      options={dadosGraficoAcidentes.options}
                      series={dadosGraficoAcidentes.series}
                      type="area"
                    />
                  </div>
                </Grid>


              </Grid>
              <Grid container item xs={3} style={{ paddingTop: '10px' }}
                justifyContent="center"
              >
                <div
                  style={{
                    flex: 1,
                    padding: '5px',
                    backgroundColor: '#191970',
                    color: 'white',
                    borderRadius: '8px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    marginInline: '10px',
                  }}
                >


                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bold',
                      padding: '5px',
                      borderBottom: '1px solid white',
                    }}
                  >
                    <span style={{ flex: 1, fontSize: '12px' }}>#</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Tipo</span>
                    <span style={{ flex: 1, fontSize: '12px' }}>Quant.</span>
                  </div>

                  {infoDashboard.rankingAcidentes?.map((ranking, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '5px',
                        backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff',
                        color: 'black',
                        fontSize: '14px',
                      }}
                    >
                      <span style={{ flex: 1, textAlign: 'center' }}>
                        {index === 0 ? '👑' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                      </span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.nome}</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>{ranking.quantidade}</span>
                    </div>
                  ))}
                </div>
              </Grid>





            </Grid>
          }
        </div>

      }

      {
        value === 1 &&
        <div style={{ paddingTop: 5, paddingLeft: 220, height: 'calc(100vh - 50px)', display: 'flex', flexDirection: 'column' }}>

          <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', p: 1 }}>
            {loading ?
              <Skeleton animation={"wave"} width={'100%'} height={400} />
              :
              <div style={{ backgroundColor: darkMode ? '#121212' : 'white', flex: 1 }}>
                {objetos && (
                  <MaterialReactTable table={table} />
                )}
              </div>
            }
          </Box>
        </div>
      }

      {
        value === 2 &&
        <div style={{ paddingTop: 5, paddingLeft: 220, flex: 1, display: 'flex', flexDirection: 'column' }}>
          {loadingMotoristas ?
            <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
            </Skeleton>
            :
            <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <div style={{ backgroundColor: darkMode ? '#121212' : 'white', flex: 1 }}>
                {motoristas && (
                  <MaterialReactTable table={tableMotoristas} />
                )}
              </div>
            </Box>
          }
        </div>
      }

      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          top: '100px', // Ajuste conforme a altura do NavegadorGestao
          height: 'calc(100vh - 100px)',
          '& .MuiDrawer-paper': {
            position: 'fixed',
            top: '100px', // Ajuste conforme a altura do NavegadorGestao
            width: '220px', // Defina a largura do Drawer conforme necessário
          },
        }}
      >
        <List>
          <ListItem
            sx={{
              backgroundColor: value === 0 ? 'orange' : 'transparent', // Fundo laranja se value === 0
            }}
            button onClick={() => handleMenuClick(0)}>
            <ListItemIcon><DashboardIcon /></ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem
            sx={{
              backgroundColor: value === 1 ? 'orange' : 'transparent', // Fundo laranja se value === 0
            }}
            button onClick={() => handleMenuClick(1)}>
            <ListItemIcon><PostAddIcon /></ListItemIcon>
            <ListItemText primary="Veículos" />
          </ListItem>

          <ListItem
            sx={{
              backgroundColor: value === 2 ? 'orange' : 'transparent', // Fundo laranja se value === 0
            }}
            button onClick={() => handleMenuClick(2)}>
            <ListItemIcon><PostAddIcon /></ListItemIcon>
            <ListItemText primary="Motoristas" />
          </ListItem>

        </List>
      </Drawer>


    </div >
  );
}



